/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DatasourceHierarchyNodeDto } from '../models/DatasourceHierarchyNodeDto';
import type { MetadataMonitoringConfigDto } from '../models/MetadataMonitoringConfigDto';
import type { SupportedDatasourcesDto } from '../models/SupportedDatasourcesDto';
import type { UpdateMonitoringConfigRequestDto } from '../models/UpdateMonitoringConfigRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MetadataMonitoringService {

    /**
     * Fetch the current global inclusion/exclusion configuration for metadata monitoring
     * @returns MetadataMonitoringConfigDto Successfully fetched configuration
     * @throws ApiError
     */
    public static getMonitoringConfig(): CancelablePromise<MetadataMonitoringConfigDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/metadata-monitoring/config',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update global inclusion/exclusion configuration and trigger monitor reconciliation
     * @returns any Configuration updated successfully
     * @throws ApiError
     */
    public static updateMonitoringConfig({
        requestBody,
    }: {
        requestBody: UpdateMonitoringConfigRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/metadata-monitoring/config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch hierarchical representation of datasources
     * @returns DatasourceHierarchyNodeDto Successfully fetched datasource hierarchy
     * @throws ApiError
     */
    public static getDatasourceHierarchy(): CancelablePromise<Array<DatasourceHierarchyNodeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/metadata-monitoring/datasource-hierarchy',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Fetch supported datasources and their possible monitoring templates
     * @returns SupportedDatasourcesDto Successfully fetched supported datasources
     * @throws ApiError
     */
    public static getSupportedDatasources(): CancelablePromise<Array<SupportedDatasourcesDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/metadata-monitoring/supported-datasources',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
